var pubsub = require('pubsub');
var gsap = require('gsap');
var Swiper = require('swiper');

module.exports = function () {
	var _swipers = document.querySelectorAll('.swiper-container:not(.fade)');

	Array.prototype.forEach.call(_swipers, function(el){
			var mySwiper = new Swiper (el, {
		    // Optional parameters
		    direction: 'horizontal',
		    loop: true,
		    threshold: 50,
		    // If we need pagination
		    pagination: el.querySelector('.swiper-pagination'),
		    paginationClickable: true,
		    // Navigation arrows
		    nextButton: '.swiper-button-next',
		    prevButton: '.swiper-button-prev',

		    // And if we need scrollbar
		    //scrollbar: '.swiper-scrollbar',
		  })
	})

	var _swipersFade = document.querySelectorAll('.swiper-container.fade');

	Array.prototype.forEach.call(_swipersFade, function(el){
		var swiper = new Swiper(el, {
	        autoplay: 4000,
			speed : 1000,
			autoplayDisableOnInteraction: false,
	        nextButton: '.swiper-button-next.swiper-button-next-fade',
	        prevButton: '.swiper-button-prev.swiper-button-prev-fade',
	        spaceBetween: 0,
	        effect: 'fade',
			loop : false, 
			fade: {
			  crossFade: false
			}
	    });
 
		/*el.onmouseover = function() {
			//pause autoplay
			swiper.stopAutoplay();
		};

		el.onmouseout = function() {
			//play autoplay
			swiper.startAutoplay();
		};*/
	});


}
